import { api } from '@smena/ui';

// Канал «MAX - личный номер УК» через self-hosted шлюз (ADR-19 драфт).
// Не путать с MAX Bot API (features/channels): там бот, здесь обычный номер оператора.

export type MaxSessionStatus = 'qr_pending' | 'password_required' | 'authorized' | 'disconnected';

export interface MaxSession {
  sessionId: string;
  accountId: string;
  status: MaxSessionStatus;
  phone?: string;
  lastError?: string;
  /** Стадия прогрева номера: пока номер холодный, первым гостю не пишем. */
  warmupState?: 'cold' | 'warming' | 'warm';
  qr?: {
    link: string;
    /** dataURL PNG - вставляем прямо в <img src>. */
    image: string;
    expiresAtMs: number;
    pollingIntervalMs: number;
  };
}

export function fetchMaxSessions(): Promise<{ items: MaxSession[]; available: boolean }> {
  return api('/api/staff/channels/max-personal');
}

export function fetchMaxSession(sessionId: string): Promise<MaxSession> {
  return api(`/api/staff/channels/max-personal/${sessionId}`);
}

export function connectMaxSession(phone?: string): Promise<MaxSession> {
  return api('/api/staff/channels/max-personal', { method: 'POST', json: { phone } });
}

export function submitMaxPassword(sessionId: string, password: string): Promise<MaxSession> {
  return api(`/api/staff/channels/max-personal/${sessionId}/password`, {
    method: 'POST',
    json: { password },
  });
}

export function disconnectMaxSession(sessionId: string): Promise<{ ok: true }> {
  return api(`/api/staff/channels/max-personal/${sessionId}`, { method: 'DELETE' });
}

export interface MaxDialog {
  chatId: number;
  title: string;
  /** Собеседник: у личного диалога MAX своего названия нет, подпись - это человек. */
  peerId?: number;
  name?: string;
  phone?: string;
}

export interface MaxHistoryImportResult {
  imported: number;
  skipped: number;
  messages: number;
  errors: string[];
  /** Что не сошлось в формате ответа MAX. Пусто - формат распознан. */
  diagnostics: string[];
}

export function fetchMaxDialogs(
  sessionId: string,
  limit = 100,
): Promise<{ items: MaxDialog[]; diagnostic?: string }> {
  return api(`/api/staff/channels/max-personal/${sessionId}/dialogs?limit=${limit}`);
}

export function importMaxHistory(
  sessionId: string,
  chatIds: number[],
  limit = 300,
): Promise<MaxHistoryImportResult> {
  return api(`/api/staff/channels/max-personal/${sessionId}/import-history`, {
    method: 'POST',
    json: { chatIds, limit },
  });
}

/** Правило игнора: чат, в который агент не пишет и который не парсит. */
export interface IgnoredChatRule {
  id: string;
  ref: string;
  kind: string;
  note: string | null;
  /** Правило платформы: показываем, но снять из панели нельзя. */
  vendor: boolean;
}

export function fetchMaxIgnored(sessionId: string): Promise<{ items: IgnoredChatRule[] }> {
  return api(`/api/staff/channels/max-personal/${sessionId}/ignored`);
}

export function addMaxIgnored(
  sessionId: string,
  chatId: string,
  note?: string,
): Promise<IgnoredChatRule> {
  return api(`/api/staff/channels/max-personal/${sessionId}/ignored`, {
    method: 'POST',
    json: { chatId, note },
  });
}

export function removeMaxIgnored(sessionId: string, ruleId: string): Promise<{ ok: true }> {
  return api(`/api/staff/channels/max-personal/${sessionId}/ignored/${ruleId}`, { method: 'DELETE' });
}
